var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    fill: "#484888",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330-730v-91q0-24 18-42t42-18h180q24 0 42 18t18 42v91h190q24 0 42 18t18 42v239H571v-60H391v60H80v-239q0-24 18-42t42-18h190Zm60 0h180v-91H390v91Zm61 359v-60h60v60h-60Zm-371 0h311v60h180v-60h309v190q0 24-18 42t-42 18H140q-24 0-42-18t-18-42v-190Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.a8f78591b6f7987175da9071da4d1f1b.svg";
export { ForwardRef as ReactComponent };